import { initializeApp } from "firebase/app";
import { 
  getStorage, 
  ref, 
  uploadBytesResumable, 
  getDownloadURL,
  type UploadTask, 
  type StorageReference
} from "firebase/storage";
import { firebaseConfig } from "../firebase.config";
import Utils from "~/services/Utils";

const firebaseApp = initializeApp(firebaseConfig);
// Initialize Cloud Storage and get a reference to the service
const storage = getStorage(firebaseApp);

export class FilesAPI {

  static uploadFile = (fileData: any, filePath = "files"): { 
    uploadTask: UploadTask, 
    uploadRef: StorageReference
  } => {
    // In case filePath is set to null or an empty string
    if (!filePath) {
      filePath = "files";
    }

    const { file: { file }, type } = fileData;
    
    // Add a random suffix to each file to prevent files with the same name from overriding each other
    // Notes that not all file types contain a file object, an example is the audio file type.
    let fileKey = file ? `${Utils.getRandomString(8)}-${file.name}` : `${Utils.getRandomString(8)}`;

    if (type) {
      // Split the MIME type string at the first slash
      let mimeTypeParts = type.split('/');
      let subtype = '';

      // Check if there is a subtype or parameter
      if (mimeTypeParts.length > 1) {
        subtype = mimeTypeParts[1].split(';')[0];
      }

      // Add the subtype to the file key if it exists
      if (subtype) {
        fileKey += `.${subtype}`;
      }

      // Add the file extension to the file key if it is missing
      if (!fileKey.endsWith(`.${subtype}`)) {
        fileKey += `.${type.split('/')[1]}`;
      }
    }

    // Create a reference to the storage location
    const uploadRef = ref(storage, `user-uploads/${filePath}/${fileKey}`);
    
    // Use uploadBytesResumable instead of uploadBytes to get an UploadTask
    // that supports progress monitoring, pause, resume, etc.
    let uploadTask: UploadTask;
    if (file) {
      uploadTask = uploadBytesResumable(uploadRef, file);
    } else {
      uploadTask = uploadBytesResumable(uploadRef, fileData);
    }

    return {
      uploadTask,
      uploadRef
    };
  };
}